/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function UpdateOrganizationAdvertisementRequestOrganizationFromJSON(json) {
    return UpdateOrganizationAdvertisementRequestOrganizationFromJSONTyped(json, false);
}
export function UpdateOrganizationAdvertisementRequestOrganizationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        hideAd: json['hide_ad']
    };
}
export function UpdateOrganizationAdvertisementRequestOrganizationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        hide_ad: value.hideAd
    };
}
